
import { useState } from 'react';

export default function TeamSection() {
  const [showContactModal, setShowContactModal] = useState(false);
  const [copyMessage, setCopyMessage] = useState('');

  const teamMembers = [
    {
      name: '张医生',
      position: '首席科学顾问',
      department: '北京燃轻元医疗技术研究院',
      description: '营养学博士，专注功能性食品研发15年',
      avatar: 'https://public.readdy.ai/ai/img_res/04a72838444f1e13124ba0e57177f168.jpg'
    },
    {
      name: '李研究员',
      position: '产品研发总监',
      department: '云南农业大学合作团队',
      description: '食品科学专家，致力于天然成分功效研究',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20Asian%20male%20researcher%20in%20casual%20business%20attire%2C%20modern%20laboratory%20background%20with%20natural%20ingredients%2C%20focused%20and%20innovative%20expression%2C%20warm%20natural%20lighting%2C%20professional%20portrait%20style%2C%20clean%20composition%2C%20scientific%20research%20and%20development%20concept&width=300&height=300&seq=team-researcher&orientation=squarish'
    },
    {
      name: '王营养师',
      position: '用户体验顾问',
      department: '注册营养师',
      description: '个性化营养方案设计专家，陪伴用户健康之旅',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20Asian%20female%20nutritionist%20with%20warm%20smile%2C%20holding%20healthy%20foods%20and%20supplements%2C%20modern%20wellness%20clinic%20background%2C%20caring%20and%20professional%20expression%2C%20natural%20lighting%2C%20approachable%20portrait%20style%2C%20health%20consulting%20concept&width=300&height=300&seq=team-nutritionist&orientation=squarish'
    }
  ];

  const achievements = [
    {
      icon: 'ri-award-line',
      number: '15+',
      label: '年研发经验',
      description: '深耕营养健康领域'
    },
    {
      icon: 'ri-flask-line', 
      number: '50+',
      label: '科学实验',
      description: '严格的产品验证流程'
    },
    {
      icon: 'ri-user-heart-line',
      number: '10W+',
      label: '用户信赖',
      description: '轻松健康管理体验'
    },
    {
      icon: 'ri-plant-line',
      number: '100%',
      label: '天然成分',
      description: '安全有效的原料选择'
    }
  ];

  const wechatId = 'ranqingyuan2024';

  const handleCopyWechat = async () => {
    try {
      await navigator.clipboard.writeText(wechatId);
      setCopyMessage('微信号已复制到剪贴板');
      setTimeout(() => setCopyMessage(''), 3000);
    } catch (err) {
      setCopyMessage('复制失败，请手动复制');
      setTimeout(() => setCopyMessage(''), 3000);
    }
  };

  // 新增的探索产品函数
  const handleExploreProducts = () => {
    // 跳转到首页并定位到产品区域
    if (window.location.pathname === '/') {
      // 已在首页，直接滚动到产品区域
      const productsSection = document.getElementById('products');
      if (productsSection) {
        productsSection.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // 不在首页，先跳转到首页再滚动到产品区域
      window.REACT_APP_NAVIGATE('/');
      setTimeout(() => {
        const productsSection = document.getElementById('products');
        if (productsSection) {
          productsSection.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  };

  return (
    <>
      <section className="py-16 lg:py-24 bg-gradient-to-b from-white to-[#f8f9fc]">
        <div className="max-w-7xl mx-auto px-6 lg:px-32">
          <div className="text-center mb-12 lg:mb-16">
            <h2 className="text-2xl lg:text-4xl font-light text-gray-800 mb-4 lg:mb-6">
              专业团队
            </h2>
            <p className="text-sm lg:text-lg text-gray-600 font-light max-w-3xl mx-auto">
              汇聚营养学、食品科学、用户体验等多领域专家，<br />
              用科学严谨的态度践行轻松哲学
            </p>
          </div>

          {/* 团队成员 */}
          <div className="grid md:grid-cols-3 gap-8 lg:gap-12 mb-16 lg:mb-24">
            {teamMembers.map((member, index) => (
              <div key={index} className="text-center group">
                <div className="relative mb-6 lg:mb-8">
                  <div className="absolute inset-0 bg-gradient-to-br from-[#847eba]/20 to-[#a3c1c3]/20 rounded-full transform group-hover:scale-110 transition-transform duration-300"></div>
                  <img 
                    src={member.avatar}
                    alt={member.name}
                    className="relative z-10 w-32 lg:w-40 h-32 lg:h-40 mx-auto object-cover rounded-full shadow-lg"
                  />
                </div>
                
                <h3 className="text-lg lg:text-xl font-medium text-gray-800 mb-2">
                  {member.name}
                </h3>
                
                <p className="text-xs lg:text-sm text-[#847eba] font-medium mb-1">
                  {member.position}
                </p>
                
                <p className="text-xs lg:text-sm text-gray-500 font-light mb-3 lg:mb-4">
                  {member.department}
                </p>
                
                <p className="text-xs lg:text-base text-gray-600 font-light leading-relaxed">
                  {member.description}
                </p>
              </div>
            ))}
          </div>

          {/* 团队成就 */}
          <div className="bg-gradient-to-br from-[#847eba]/5 to-[#a3c1c3]/5 rounded-3xl p-8 lg:p-12">
            <div className="text-center mb-8 lg:mb-12">
              <h3 className="text-lg lg:text-xl font-medium text-gray-800 mb-4 lg:mb-6">
                团队成就
              </h3>
              <p className="text-xs lg:text-base text-gray-600 font-light">
                用数据说话，用专业护航每一个轻松的健康之旅
              </p>
            </div>
            
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
              {achievements.map((achievement, index) => (
                <div key={index} className="text-center">
                  <div className="w-12 lg:w-16 h-12 lg:h-16 bg-gradient-to-br from-[#847eba] to-[#a3c1c3] rounded-2xl flex items-center justify-center mx-auto mb-3 lg:mb-4">
                    <i className={`${achievement.icon} text-lg lg:text-xl text-white`}></i>
                  </div>
                  
                  <div className="text-lg lg:text-2xl font-medium text-[#847eba] mb-1">
                    {achievement.number}
                  </div>
                  
                  <div className="text-xs lg:text-sm font-medium text-gray-800 mb-1">
                    {achievement.label}
                  </div>
                  
                  <div className="text-xs lg:text-sm text-gray-600 font-light">
                    {achievement.description}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* 联系我们 */}
          <div className="text-center mt-12 lg:mt-16">
            <div className="bg-white rounded-3xl p-8 lg:p-12 shadow-lg border border-gray-100 max-w-2xl mx-auto">
              <h3 className="text-lg lg:text-xl font-medium text-gray-800 mb-4 lg:mb-6">
                加入我们的轻松之旅
              </h3>
              <p className="text-xs lg:text-base text-gray-600 font-light leading-relaxed mb-6 lg:mb-8">
                有任何关于产品或健康管理的问题，<br />
                我们的专业团队随时为您提供温暖的支持与陪伴
              </p>
              
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <button 
                  onClick={() => setShowContactModal(true)}
                  className="inline-flex items-center justify-center px-6 lg:px-8 py-3 lg:py-4 bg-[#847eba] text-white hover:bg-[#6b5d9a] transition-all duration-300 rounded-full text-sm lg:text-base font-medium whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-customer-service-2-line mr-2"></i>
                  联系我们
                </button>
                
                <button 
                  onClick={handleExploreProducts}
                  className="inline-flex items-center justify-center px-6 lg:px-8 py-3 lg:py-4 border-2 border-[#847eba] text-[#847eba] hover:bg-[#847eba] hover:text-white transition-all duration-300 rounded-full text-sm lg:text-base font-medium whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-shopping-bag-line mr-2"></i>
                  探索产品
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 联系我们弹窗 */}
      {showContactModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          {/* 毛玻璃背景 */}
          <div 
            className="absolute inset-0 bg-black/30 backdrop-blur-sm"
            onClick={() => setShowContactModal(false)}
          ></div>
          
          {/* 弹窗内容 */}
          <div className="relative bg-gradient-to-br from-[#847eba]/95 to-[#6b5d9a]/95 backdrop-blur-md rounded-3xl p-8 lg:p-10 max-w-md w-full mx-4 shadow-2xl transform transition-all duration-300">
            {/* 关闭按钮 */}
            <button 
              onClick={() => setShowContactModal(false)}
              className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center text-white/80 hover:text-white hover:bg-white/20 rounded-full transition-all duration-200 cursor-pointer"
            >
              <i className="ri-close-line text-lg"></i>
            </button>

            {/* 标题 */}
            <div className="text-center mb-6">
              <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-wechat-fill text-2xl text-white"></i>
              </div>
              <h3 className="text-lg lg:text-xl font-medium text-white mb-2">联系我们</h3>
              <p className="text-white/80 text-xs lg:text-sm">扫码或添加微信号与我们交流</p>
            </div>

            {/* 二维码 */}
            <div className="text-center mb-6">
              <div className="bg-white rounded-2xl p-4 inline-block mb-4">
                <img 
                  src="https://readdy.ai/api/search-image?query=WeChat%20QR%20code%20for%20health%20and%20wellness%20brand%20contact%2C%20clean%20white%20background%2C%20minimalist%20design%2C%20professional%20business%20QR%20code%20style%2C%20clear%20and%20scannable%2C%20modern%20tech%20design&width=200&height=200&seq=wechat-qr&orientation=squarish"
                  alt="微信二维码"
                  className="w-32 h-32 object-contain"
                />
              </div>
              <p className="text-white/90 text-xs lg:text-sm">扫描二维码添加微信</p>
            </div>

            {/* 微信号 */}
            <div className="bg-white/20 rounded-2xl p-4 mb-4">
              <div className="flex items-center justify-between">
                <div className="flex items-center">
                  <i className="ri-user-line text-white mr-3"></i>
                  <div>
                    <p className="text-white/80 text-xs">微信号</p>
                    <p className="text-white font-medium text-xs lg:text-base">{wechatId}</p>
                  </div>
                </div>
                <button 
                  onClick={handleCopyWechat}
                  className="px-3 py-1 bg-white/30 hover:bg-white/40 text-white text-xs lg:text-sm rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-file-copy-line mr-1"></i>
                  复制
                </button>
              </div>
            </div>

            {/* 复制提示 */}
            {copyMessage && (
              <div className="text-center mb-4">
                <p className="text-white/90 text-xs lg:text-sm bg-white/20 rounded-full px-4 py-2 inline-block">
                  <i className="ri-check-line mr-1"></i>
                  {copyMessage}
                </p>
              </div>
            )}

            {/* 温馨提示 */}
            <div className="text-center">
              <p className="text-white/70 text-xs leading-relaxed">
                我们通常在工作时间内回复消息<br />
                工作时间：周一至周五 9:00-18:00
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
